// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__-quKP","subheader":"ReorderModal_subheader__3AIIa","listWrap":"ReorderModal_listWrap___oWKz"};